import { FC } from "react";

interface IconHeartProps {
  className?: string;
  fill?: string;
}

const IconHeart: FC<IconHeartProps> = ({ className, fill }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M2 10.1371C2 15 6.01943 17.5914 8.96173 19.9109C10 20.7294 11 21.5 12 21.5C13 21.5 14 20.7294 15.0383 19.9109C17.9806 17.5914 22 15 22 10.1371C22 5.27416 16.4998 1.82546 12 6.50063C7.50016 1.82546 2 5.27416 2 10.1371Z"
        fill={fill ?? "#4F5E71"}
      />
    </svg>
  );
};

export default IconHeart;
